
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  IRequestedAmount,
  ISolCustomerCurrency,
  ISolCustomerDenomination,
  ISolCustomerPack,
  IUserDetailData,
} from "@/entities";
import { ISolCustomerDenominationParams, ISolCustomerDenominationResponse } from "@/services";
import { Action, Getter } from "vuex-class";
import { Locale } from "@/store";

@Component({
  name: "detail-delivery",
})
export default class DetailDelivery extends Vue {
  @Getter("getLoggedUser") getLoggedUser!: IUserDetailData;
  @Getter("getLocale") locale!: Locale;
  @Getter("getSolCustomerCurrencies") solCustomerCurrencies!: ISolCustomerCurrency[];
  @Action("fetchSolCustomerDenominations") fetchSolCustomerDenominations!: (
    params: ISolCustomerDenominationParams
  ) => Promise<ISolCustomerDenominationResponse | undefined>;
  @Prop({ required: true })
  requestedAmounts!: IRequestedAmount[] | undefined;
  @Prop({ required: true })
  packs!: ISolCustomerPack[] | undefined;
  denominations: ISolCustomerDenomination[] | undefined = [];

  constructor() {
    super();
  }

  async mounted(): Promise<void> {
    this.denominations = await this.fetchDenominations();
  }

  async fetchDenominations(): Promise<ISolCustomerDenomination[] | undefined> {
    const requests = this.requestedAmountByCurrency.map((requestedAmount) => {
      const params = {
        countryCode: this.getLoggedUser?.country?.code,
        currencyId:
          requestedAmount.currencyId ??
          this.getCurrencyByIsoCode(requestedAmount.currencyIsoCode)?.currencyId,
      } as ISolCustomerDenominationParams;

      return this.fetchSolCustomerDenominations(params);
    });

    const results = await Promise.all(requests);
    return results.flatMap((res) => res?.denominations || []);
  }

  getDenomination(denominationId: string): ISolCustomerDenomination | undefined {
    return this.denominations?.find((d) => d.id === denominationId);
  }

  getCurrencyByIsoCode(isoCode: string | undefined): ISolCustomerCurrency | undefined {
    return this.solCustomerCurrencies.find((c) => c.isoCode === isoCode);
  }

  getPack(packId: string): ISolCustomerPack | undefined {
    return this.packs?.find((p) => p.id === packId);
  }

  get requestedAmountByCurrency(): IRequestedAmount[] {
    const amountsByCurrency: IRequestedAmount[] = [];
    this.requestedAmounts?.forEach((value) => {
      const amountByCurrency = amountsByCurrency.find(
        (requestedAmount) => requestedAmount.currencyIsoCode === value.currencyIsoCode
      );

      if (amountByCurrency) {
        amountByCurrency.totalAmount =
          (amountByCurrency.totalAmount || 0) + (value.totalAmount || 0);
      } else {
        amountsByCurrency.push({ ...value });
      }
    });
    return amountsByCurrency;
  }

  get requestedAmountsWithPacks(): IRequestedAmount[] {
    return this.requestedAmounts?.filter((r) => r.packs?.length) || [];
  }
  get requestedAmountsWithDenominations(): IRequestedAmount[] {
    return this.requestedAmounts?.filter((r) => r.denominations?.length) || [];
  }

  get requestedAmountsWithCommodity(): IRequestedAmount[] {
    return (
      this.requestedAmounts?.filter(
        (r) =>
          !r.packs?.length &&
          !r.denominations?.length &&
          r.totalAmount != null &&
          (!!r.commodityDescription || !!r.commodityCode)
      ) || []
    );
  }
}
